import PropTypes from "prop-types";
import capitalize from "capitalize";
import { UserSolidV6 } from "@shared/v2/Icomoon";
import HomeInfoOverlay from "./HomeInfoOverlay";
import BaseEvent from "./BaseEvent";

const TimelineSubmittedFormEvent = ({
  event,
  event: {
    timeline_fields: { property, ...timelineFields },
    event_type: eventType,
    schedule_tour_type: scheduleTourType,
  },
}) => {
  const isForcedSearch =
    eventType === "forced_registration_search_page_combined" && timelineFields.search_url;
  const descriptions = [];

  if (scheduleTourType) descriptions.push(`Type: ${scheduleTourType}`);
  Object.keys(timelineFields).forEach((key) => {
    // Internal attribution fields, not form answers — see helpers/updaterAttribution.
    if (key === "updater_name" || key === "updater_type") return;
    const titleizedKey = key
      .split("_")
      .map((element) => capitalize(element))
      .join(" ");
    if (titleizedKey === "Search Url" && timelineFields.search_url) {
      descriptions.push(`${titleizedKey}: <span style="color: #59C4C4;">View Search</span>`);
    } else {
      descriptions.push(`${titleizedKey}: ${timelineFields[key]}`);
    }
  });

  return (
    <BaseEvent
      icon={<UserSolidV6 />}
      title={
        <div>
          <span className="tw-font-semibold">Submitted Form: </span>
          {event.titleized_type}
        </div>
      }
      onClick={() => {
        if (isForcedSearch) window.open(timelineFields.search_url);
        else if (property?.url) window.open(property.url);
      }}
      interactedAt={event.interacted_at_absolute}
    >
      {!isForcedSearch && property && <HomeInfoOverlay timelineFields={property} />}
      {descriptions.length > 0 && <div className="tw-font-semibold">Details:</div>}
      <div className="tw-flex tw-flex-col tw-gap-[8px]">
        {descriptions.map((description) => (
          <div key={`${event.id}-${description}`} dangerouslySetInnerHTML={{ __html: description }} />
        ))}
      </div>
    </BaseEvent>
  );
};

TimelineSubmittedFormEvent.propTypes = {
  event: PropTypes.shape().isRequired,
};

export default TimelineSubmittedFormEvent;
